import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
import MyTickets from './pages/MyTicketsPage';
import SmtpPage from './pages/SmtpPage';
import UsersPage from './pages/UsersPage';
import CheckbookAccounts from './pages/CheckbookAccounts';
import Checkbooks from './pages/Checkbooks';
import PrintWorkbookPage from './pages/PrintWorkbookPage';
import TicketsCategoryPage from "./pages/TicketsCategoryPage";
import AdminTicketsPage from './pages/AdminTicketsPage';
import ReportTicketsPage from './pages/ReportTicketsPage';
import PersonalitiesPage from './pages/PersonalitiesPage';
import PersonalitiesInstitutionsPage from './pages/PersonalitiesInstitutionsPage';
import InvitationDetails from './pages/InvitationDetails';
 import InvitationsPage from './pages/InvitationsPage';
 import InventoryAdmin from './pages/InventoryAdmin';
import LoginPage from './pages/LoginPage';
import RecoverPassword from './pages/RecoverPassword'
import Page404 from './pages/Page404';
import ValidateAuth from "./utils/validateAuth"
import PermissionGuard from "./utils/PermissionGuard"
import { useAuth } from './context/AuthContext';
import EnrollmentPage from './pages/EnrollmentPage';
import EnrollmentRegisterpage from './pages/EnrollmentRegisterpage';
import EnrollmentDetailsTab from './pages/EnrollmentDetailsTab';
import ComunicationsPage from './pages/ComunicationsPage';
import TrainingService from './pages/TrainingService'
import TrainingServicePage from './pages/TrainingsServicePage'
import CapacitacionesPage from './pages/CapacitacionesPage'
import AppMovilPage from './pages/AppMovilPage'

export default function Router() {

  const {currentUser} = useAuth()

  const tempRoutes = [
    {
      path: '/',
      element: <ValidateAuth component={DashboardLayout}/>,
      children: [
        { element: (currentUser?.role.some(role=>role === "Administrador Tickets") || currentUser?.role?.some(role=>role === "Soporte")) ? <Navigate to="/ticketsAdmin" /> : <Navigate to="/tickets" />, index: true },
        { path: 'tickets', element: <PermissionGuard component={MyTickets} requiredRoles={['Usuario','Soporte','Administrador','Administrador Tickets']} /> },
        { path: 'ticketsAdmin', element: <PermissionGuard component={AdminTicketsPage} requiredRoles={['Administrador Tickets','Soporte']} /> },
        { path: 'ticketsReport', element: <PermissionGuard component={ReportTicketsPage} requiredRoles={['Administrador Tickets','Soporte']} /> },
        { path: 'ticketsCategory', element: <PermissionGuard component={TicketsCategoryPage} requiredRoles={['Administrador Tickets','Soporte']} /> },
        { path: 'users', element: <PermissionGuard component={UsersPage} requiredRoles={['Administrador']} /> },
        { path: 'checkbookAccounts', element: <PermissionGuard component={CheckbookAccounts} requiredRoles={['Imprimir Cheques']} /> },
        { path: 'checkbooks', element: <PermissionGuard component={Checkbooks} requiredRoles={['Imprimir Cheques']} /> },
        { path: 'printWorkbookPage', element: <PermissionGuard component={PrintWorkbookPage} requiredRoles={['Imprimir Cheques']} /> },
        { path: 'personalities', element: <PermissionGuard component={PersonalitiesPage} requiredRoles={['Personalities']} /> }, 
        { path: 'personalitiesInstitutions', element: <PermissionGuard component={PersonalitiesInstitutionsPage} requiredRoles={['Personalities Admin']} /> },
        { path: 'invitationsPage', element: <PermissionGuard component={InvitationsPage} requiredRoles={['Personalities Admin']} /> },
        { path: 'invitationsDetails', element: <PermissionGuard component={InvitationDetails} requiredRoles={['Personalities Admin']} /> },
        { path: 'inventory', element: <PermissionGuard component={InventoryAdmin} requiredRoles={['Administrador']} /> },
        { path: 'enrollment', element: <PermissionGuard component={EnrollmentPage} requiredRoles={['Administrador']} />},
        { path: 'enrollmentDetails', element: <PermissionGuard component={EnrollmentDetailsTab} requiredRoles={['Administrador']} />},
        { path: 'communications', element: <PermissionGuard component={ComunicationsPage} requiredRoles={['Communications']} />},
        { path: 'capacitaciones', element: <PermissionGuard component={CapacitacionesPage} requiredRoles={['Administrador']} />},
        { path: 'appMovil', element: <PermissionGuard component={AppMovilPage} requiredRoles={['Administrador']} /> },
        
        {
          path: '/smtp',
          children: [
            { path: '', element: <PermissionGuard component={SmtpPage} requiredRoles={['Administrador']} /> }
          ]
        }
      ]
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    { path: 'capacitacion', 
      element: <TrainingService />},
    {
      path: 'recoverPassword/:tempToken?',
      element: <RecoverPassword />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    { path: 'registerEnrollment/:enrollmentId', element: <EnrollmentRegisterpage />, index: true },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]

  const routes = useRoutes(tempRoutes);

  return routes;
}
